import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const SvgExchange: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10317_3098)">
        <path
          d="M35.3412 9.25635H13.7927C12.5896 9.25635 11.4357 9.7343 10.5849 10.5851C9.73417 11.4358 9.25623 12.5897 9.25623 13.7929V38.7438L14.9269 35.3414L20.5975 38.7438L24.0331 36.6824M35.3412 9.25635C34.4388 9.25635 33.5734 9.61482 32.9354 10.2529C32.2972 10.891 31.9388 11.7564 31.9388 12.6587V23.0446M35.3412 9.25635C36.2436 9.25635 37.109 9.61482 37.7471 10.2529C38.3851 10.891 38.7436 11.7564 38.7436 12.6587V20.5977H31.9388"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.0341 26.9575H30.6666V30.667H26.9573V35.0345H30.6666V38.7438H35.0341V35.0345H38.7435V30.667H35.0341V26.9575Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9023 16.7222V14.2793"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4596 23.2367C14.4596 24.4582 15.5508 24.8654 16.9025 24.8654C18.2543 24.8654 19.3455 24.8654 19.3455 23.2367C19.3455 20.7937 14.4596 20.7937 14.4596 18.3508C14.4596 16.7222 15.5508 16.7222 16.9025 16.7222C18.2543 16.7222 19.3455 17.341 19.3455 18.3508"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9023 24.8652V27.3082"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7094 21.6392H26.0106"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7094 17.2812H27.5194"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10317_3098">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
